import Aos from "aos";
import React, { useEffect } from "react";
import { sofaItems } from "../data";
import SofaItems from "../Items/SofaItems";
import { Link } from "react-router-dom";

const SofaSet = () => {
  useEffect(() => {
    Aos.init({ once: true });

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  });
  return (
    <>
      <div
        className="flex flex-col items-center lg:mt-[90px] sm:mt-[65px] mt-[30px]"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 lg:px-0 px-5">
          <div
            className="flex flex-col items-center gap-2 "
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h3 className=" text-[38px] sm:text-[44px] md:text-[48px] font-medium text-black-900 text-center">
              Sofabed
            </h3>
            <p className=" text-[16px] font-normal text-gray-600_01 text-center">
              Prečo zvoliť sedačku na každodenné spanie (sofabed) ?
            </p>
          </div>
          <div>
            <p
              className=" text-[16px] font-normal text-gray-600_01"
              style={{ textAlign: "justify" }}
            >
              <b>Sedacie súpravy určené na každodenné spanie</b>, známe aj ako
              sofabed, predstavujú praktické riešenie pre ľudí, ktorí potrebujú
              kombinovať pohodlné sedenie počas dňa s kvalitným spánkom v noci.
              Ich hlavnou výhodou je úspora priestoru, čo ocenia najmä majitelia
              menších bytov alebo garsóniek. Moderné sofabed modely sú navrhnuté
              tak, aby poskytovali dostatočnú oporu chrbtici, čím eliminujú
              problémy spojené s dlhodobým spánkom na klasických rozkladacích
              pohovkách. Navyše, vďaka rôznym mechanizmom rozkladania je ich
              premena z pohovky na posteľ rýchla a jednoduchá.
            </p>
            <video controls style={{ marginTop: "25px", marginBottom: "25px" }}>
              <source src="assets/Vids/emma.mp4" type="video/mp4" />
            </video>
            <p
              className=" text-[16px] font-normal text-gray-600_01"
              style={{ marginTop: "10px", textAlign: "justify" }}
            >
              Okrem praktickosti ponúkajú aj estetický prínos do interiéru.
              Výrobcovia dnes ponúkajú širokú škálu dizajnov, farieb a
              materiálov, vďaka čomu sa sofabed dokáže harmonicky zladiť s
              akýmkoľvek štýlom bývania. Mnohé modely navyše disponujú úložným
              priestorom, ktorý poslúži na odkladanie posteľnej bielizne či
              sezónnych vecí. <b>Sofabed</b> tak predstavuje ideálne riešenie
              nielen pre domácnosti, ale aj pre hosťovské izby či študentské
              ubytovanie, kde je potrebné efektívne využiť každý meter
              priestoru.
            </p>
            <p
              className=" text-[16px] font-normal text-gray-600_01"
              style={{ marginTop: "10px", textAlign: "justify" }}
            >
              Ďalšou významnou výhodou{" "}
              <Link
                to="https://www.dreamsofa.sk/emma/"
                style={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  marginRight: "5px",
                }}
              >
                sedačky na každodenné spanie
              </Link>
              je ich ekonomická výhodnosť. Namiesto investície do samostatnej
              pohovky a postele stačí jedno multifunkčné riešenie, ktoré spĺňa
              obe funkcie bez kompromisov v pohodlí. Moderné modely sú vyrábané
              z kvalitných materiálov, ktoré zabezpečujú dlhú životnosť a
              odolnosť pri každodennom používaní. Navyše, vďaka pokročilým
              technológiám výroby sú tieto sedačky čoraz ergonomickejšie, čo
              znamená, že ponúkajú rovnaký komfort ako klasická posteľ s
              matracom. Sofabed je preto ideálnou voľbou pre tých, ktorí hľadajú
              spojenie praktickosti, pohodlia a štýlu v jednom kuse nábytku.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SofaSet;
